module.exports = __webpack_public_path__ + "d63a298578700c5bf26b310223bfb804.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/paypal-monogram.png
// module id = 218
// module chunks = 0